module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.6078/img/callout-blobs.svg"